import { ParsedUrlQuery } from 'querystring';

export function getReducedPriceOnly(query: ParsedUrlQuery) {
    if (query['reduced_price_only']) {
        return query['reduced_price_only'];
    }

    return '';
}
